/* Alpacas Foods — acordeão de FAQ. Porta FAQItem (FAQ.tsx). Abre um por vez. */
(function () {
  'use strict';
  document.addEventListener('click', function (e) {
    var q = e.target.closest('.alp-faq__q');
    if (!q) return;
    var item = q.closest('.alp-faq__item');
    var faq = q.closest('.alp-faq');
    var willOpen = !item.classList.contains('is-open');
    if (faq) faq.querySelectorAll('.alp-faq__item.is-open').forEach(function (it) {
      it.classList.remove('is-open');
      var b = it.querySelector('.alp-faq__q'); if (b) b.setAttribute('aria-expanded', 'false');
    });
    item.classList.toggle('is-open', willOpen);
    q.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
  });
})();
